export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Companies',
      url: '/companies',
      classes: ['btn-success'],
      icon: 'fa fa-building'
      /* children: [
        {
          name: 'View all Companies',
          url: '/companies',
          icon: 'fa fa-building'
        },
        {
          name: 'Register Company',
          url: '/companies/register',
          icon: 'fa fa-building'
        }
      ] */
    },
    {
      name: 'Devices',
      url: '/devices',
      icon: 'fa fa-tablet'
      /* children: [
        {
          name: 'View all Devices',
          url: '/devices',
          icon: 'fa fa-tablet'
        },
        {
          name: 'Register Device',
          url: '/devices/register',
          icon: 'fa fa-tablet'
        },
        {
          name: 'Send Email',
          url: '/devices/sendemail',
          icon: 'fa fa-tablet'
        }
      ] */
    },
    /* {
      name: 'Promotions',
      url: '/promotions',
      icon: 'fa fa-envelope'
    }, */
    {
      name: 'Device Usage',
      url: '/device-usage',
      icon: 'fa fa-database'
    }
  ]
}
